<template>
  <div
    id="todo-app"
    class="border border-solid border-b-0 d-theme-border-grey-light rounded relative overflow-hidden center"
  >
    <!-- <div class="vx-col w-full sm:w-1/6 ml-auto flex justify-end">
      <vs-button
        @click="logout"
        class="cursor-pointer hover:bg-primary hover:text-white"
        color="danger"
        type="gradient"
        icon-pack="feather"
        icon="icon-log-out"
      >Logout</vs-button>
    </div>-->
    <booking-detail-prompt
      :displayPrompt="displayPrompt"
      :booking="bookingToShow"
      @hideDisplayPrompt="hidePrompt"
      v-if="displayPrompt"
    ></booking-detail-prompt>

    <vs-avatar size="70px" :src="bookingLogo" vs-type="flex" vs-justify="center"></vs-avatar>
    <!-- <span>{{$store.state.AppActiveUser.email}}</span> -->

    <h2
      class="mb-3 flex justify-center"
    >AVERAGE ETA IS {{averageETA=='0'?'.......':averageETA}} mins</h2>
    <div
      class="border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
    >
      <h3 class="mb-3 flex justify-center">Booking List</h3>
      <!-- <vx-card title="Booking List"> -->
      <!-- Booking LIST -->

      <component
        :is="scrollbarTag"
        class="todo-content-scroll-area"
        :settings="settings"
        :key="$vs.rtl"
      >
        <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
          <li
            class="cursor-pointer todo_todo-item"
            v-for="(booking, index) in bookingList"
            :key="String(booking.id)"
            :style="[{transitionDelay: (index * 0.1) + 's'}]"
          >
            <booking-row
              :booking="booking"
              @showDisplayPrompt="showDisplayPrompt($event)"
              :key="String(booking.id) + String(booking.status)"
            />
          </li>
        </transition-group>
      </component>
    </div>
    <vs-input
      name="Name"
      class="w-full mb-4 mt-5"
      placeholder="Name (optional) "
      v-model="customer.name"
    />

    <vs-button @click="bookNow" class="w-full large">BookNow</vs-button>
  </div>
</template>
<script>
import { _createBooking, _list, _avgETA } from "@/services/Booking.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import BookingDetailPrompt from "./booking/BookingDetail";
import BookingRow from "./booking/BookingRow";
export default {
  components: {
    VuePerfectScrollbar,
    BookingDetailPrompt,
    BookingRow,
  },
  data() {
    return {
      bookingList: [],
      displayPrompt: false,
      bookingLogo: require("@/assets/images/logo/logo.png"),
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      bookingToShow: {},
      averageETA: 0,
      venue: this.$store.state.venue,
      customer: {
        name: "",
      },
    };
  },
  mounted() {
    this.getBookings();
    this.getAvgETA();
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    getBookings() {
      _list()
        .then((response) => {
          this.bookingList = response.data.obj.list;
        })
        .catch((error) => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    getAvgETA() {
      _avgETA().then(
        (response) => {
          // console.log(response.data);
          this.averageETA = response.data.obj.averageMinutes;
        },
        (error) => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            position: "bottom-center",
            icon: "icon-cross_box",
            color: "warning",
          });
        }
      );
    },


    bookNow() {
      this.$vs.loading({
        text: "Please wait",
      });
      let data = {
        venueId: this.venue.id,
        companyApiId: this.$store.state.company.apiID,
        customer: this.customer,
        pickupDueTime: new Date(),
        destination: {
          _text: null,
          lat: null,
          lng: null,
          placeId: null,
        },
        pickup: {
          _text: this.venue.street,
          lat: parseFloat(this.venue.latitude),
          lng: parseFloat(this.venue.longitude),
        },
      };
      _createBooking(data)
        .then((response) => {
          this.$vs.loading.close();
          this.customer = {};
          this.bookingList.push(response.data.obj.booking);
        }  )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    showDisplayPrompt(item) {
      this.bookingToShow = item;
      this.displayPrompt = true;
    },

    hidePrompt() {
      this.displayPrompt = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";

.no-scroll-content {
  height: calc(var(--vh, 1vh) * 100 - 22rem) !important;
}
.center {
  text-align: center;
}
.large {
  padding: 3rem !important;
}
</style>
